module.exports = __webpack_public_path__ + "img/design.273109c8.png";